import React from 'react';
import { Route, Switch } from 'react-router-dom';

import FrontPage from '../pages/FrontPage';
import CarPartsPage from '../pages/CarPartsPage';
import CarPartItemPage from '../pages/CarPartItemPage';
import ArchivePage from '../pages/ArchivePage';
import PostPage from '../pages/PostPage';
import CartPage from '../pages/CartPage';
import CheckoutPage from '../pages/CheckoutPage';
import CheckoutCompletePage from '../pages/CheckoutCompletePage';
import NotFoundPage from '../pages/NotFoundPage';
import Page from '../pages/Page';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={FrontPage} />

      <Route exact path="/bildeler/" component={CarPartsPage} />

      <Route
        exact
        path="/bildeler/:carPartItemId"
        component={CarPartItemPage}
      />

      <Route exact path="/handlekurv" component={CartPage} />

      <Route exact path="/checkout" component={CheckoutPage} />

      <Route
        exact
        path="/checkout/complete/:klarnaOrderId"
        component={({ match }) => (
          <CheckoutCompletePage klarnaOrderId={match.params.klarnaOrderId} />
        )}
      />

      <Route exact path="/aktuelt" component={ArchivePage} />

      <Route
        exact
        path="/aktuelt/:postId"
        component={({ match }) => <PostPage postId={match.params.postId} />}
      />

      <Route exact path="/404" component={NotFoundPage} />

      <Route
        path="/"
        component={({ location, history }) => (
          <Page path={location.pathname} history={history} />
        )}
      />
    </Switch>
  );
}
